<template>
  <div class="content">
    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <div class="row h-100">
          <div class="col h-100">
            <card-item
              class="striped-tabled-with-hover"
              body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="d-flex justify-content-between">
                  <div>
                    <h4 class="card-title">Roles del usuario: {{ nombre }}</h4>
                    <p class="card-category">Roles</p>
                  </div>
                </div>
              </template>

              <div class="container-fluid h-100">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="quickFilter" class="label"
                        >Filtro rapido</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="quickFilter"
                        v-model="filtroRapido"
                      />
                    </div>
                  </div>
                </div>
                <div class="row" style="height: 100%">
                  <div class="col" style="position: relative; height: 100%">
                    <ag-grid-vue
                      style="width: 100%; height: 60vh"
                      class="ag-theme-alpine"
                      :columnDefs="columnDefs"
                      :rowData="roles"
                      :rowSelection="'multiple'"
                      :rowMultiSelectWithClick="true"
                      @grid-ready="onGridReady"
                    >
                    </ag-grid-vue>
                  </div>
                </div>
                <div class="d-flex justify-content-between m-2">
                  <button @click="volver" class="btn btn-danger">Volver</button>
                  <button @click="submit" v-promise-btn class="btn btn-primary">
                    Confirmar
                  </button>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { get } from "lodash-es";
import axios from "axios";
import { AgGridVue } from "ag-grid-vue";
export default {
  name: "AsignarRoles",
  components: {
    AgGridVue,
  },
  data: () => ({
    columnDefs: [
      {
        field: "id_rol",
        headerName: "#",
        flex: 1,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        showDisabledCheckboxes: true,
        sortable: true,
        comparator: (a, b, nodeA, nodeB) => {
          if (nodeA.isSelected() && !nodeB.isSelected()) {
            return -1;
          } else if (!nodeA.isSelected() && nodeB.isSelected()) {
            return 1;
          } else {
            return nodeA.data.id_rol
              .toString()
              .localeCompare(nodeB.data.id_rol.toString());
          }
        },
      },
      { field: "nombre", headerName: "Nombre", flex: 2 },
    ],
    roles: [],
    idUsuario: null,
    rolesDeUsuario: [],
    nodos: [],
    filtroRapido: "",
    gridApi: null,
    gridColumnApi: null,
    nombre: null,
  }),
  mounted() {
    this.idUsuario = this.$router.currentRoute.params.id_usuario;
  },
  methods: {
    volver() {
      this.$router.push(`/admin/users/`);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.getData();
    },
    async getData() {
      this.gridApi.showLoadingOverlay();

      const resp = await axios.post("/execute", {
        method: "SEC.GetRolesByUsuarioId",
        parameters: [{ name: "id_usuario", value: this.idUsuario }],
      });
      if (resp.data.ok) {
        this.rolesDeUsuario = get(resp, "data.result[0]", []);
        this.nombre = get(resp, "data.result[0][0].NomUsuario", "");
      } else {
        this.$msgBoxOk(resp.data.message);
      }

      const respRoles = await axios.post("/execute", {
        method: "SEC.GetRoles",
        parameters: [],
      });
      if (respRoles.data.ok) {
        this.roles = get(respRoles, "data.result[0]", []);
      } else {
        this.$msgBoxOk(respRoles.data.message);
      }

      setTimeout(() => {
        this.pintarSeleccionados();
        this.gridApi.hideOverlay();
      }, 0);
    },
    pintarSeleccionados() {
      const obj = {};
      this.rolesDeUsuario.forEach((rol) => (obj[rol.id_rol] = rol));
      this.gridApi.forEachNode((node) => {
        if (obj[node.data.id_rol]) {
          node.setSelected(true);
        }
      });
      this.gridColumnApi.applyColumnState({
        state: [{ colId: "id_rol", sort: "asc", sortIndex: 0 }],
      });
    },
    async submit() {
      const nodos = this.gridApi.getSelectedNodes();

      const mapRoles = nodos.map((node) => node.data.id_rol);

      try {
        const resp = await axios.post("/execute", {
          method: "SEC.AsignarRolesAUsuario",
          parameters: [
            { name: "id_usuario", value: this.idUsuario },
            { name: "rolesIds", value: mapRoles.join(",") },
          ],
        });
        if (resp.data.ok) {
          await this.getData();
          this.$msgBoxOk("Rol asignado con éxito!");
        }
      } catch (error) {
        console.log("error", error.message);
      }
    },
  },
  watch: {
    filtroRapido(value) {
      this.gridApi.setQuickFilter(value);
    },
  },
};
</script>
<style scoped></style>
